import MigrationLink from '@shared/components/MigrationLink/MigrationLink';
import useMsalUser from '@shared/hooks/useMsalUser';
import useNavigateToSearch from '@shared/hooks/useNavigateToSearch';
import urlData from '@shared/utilities/routes';
import React from 'react';

import CartIcon from '../Icons/CartIcon';
import styles from './RightNavMobile.module.scss';

const GavelIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="currentColor">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M1 21h12v2H1v-2zM5.24 8.07l2.83-2.83 14.14 14.14-2.83 2.83L5.24 8.07zM12.32 1l5.66 5.66-2.83 2.83-5.66-5.66L12.32 1zM3.83 9.48l5.66 5.66-2.83 2.83L1 12.31l2.83-2.83z" />
    </svg>
);

const UserIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="currentColor">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z" />
    </svg>
);

const SearchIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="currentColor">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
    </svg>
);

const RightNavMobile: React.FC = () => {
    const { isAuthenticated, signIn } = useMsalUser();

    const login = async () => signIn();
    const goToSearch = useNavigateToSearch();

    return (
        <ul className={styles['header-list']}>
            {isAuthenticated && (
                <>
                    <li>
                        <MigrationLink config={urlData.checkin}>
                            <GavelIcon />
                        </MigrationLink>
                    </li>
                    <li>
                        <MigrationLink config={urlData.myAuctions}>
                            <UserIcon />
                        </MigrationLink>
                    </li>
                    <li>
                        <button onClick={goToSearch} aria-label="search inventory link">
                            <SearchIcon />
                        </button>
                    </li>
                    <li>
                        <CartIcon />
                    </li>
                </>
            )}
            {!isAuthenticated && (
                <li>
                    <hzn-button compact onClick={login} variant="cta" aria-label="sign in">
                        SIGN IN
                    </hzn-button>
                </li>
            )}
        </ul>
    );
};

export default RightNavMobile;
